import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { Global } from '../classes/Global';
import { BaseComponent } from '../classes/BaseComponent';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { StringHelper } from '../helpers/StringHelper';
import { Log } from '../helpers/Log';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [ AuthenticationService ]
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {

  email: string;
  invalidEmail: boolean;
  serverMessage: string;
  serverError: boolean;
  showSuccess: boolean;

  @Output() onOk = new EventEmitter();

  constructor(private authenticationService: AuthenticationService) {
    super();
  }

  ngOnInit() {
    this.invalidEmail = false;
    this.serverMessage = "";
    this.serverError = false;
    this.showSuccess = false;
  }

  submit() {

    this.serverError = false;

    if(!ValidationHelper.isValidString(this.email) || !ValidationHelper.isValidEmail(this.email)) {
      this.invalidEmail = true;
      return;
    }

    this.invalidEmail = false;

    this.authenticationService.resetPassword(Global.getCountry(), this.email).subscribe(res => {
      
      if(res && res["status"] == "success") {
        this.showSuccess = true;
      }
      else {
        this.serverError = true;
        this.serverMessage = res["message"];
      }
      
    }, err => {
      Log.getInstance().d(err);
    });
  }

  onEmailChange(email) {
    this.email = email;
  }

  getEmailSentTo(): string {
    return StringHelper.format(this.getString("anEmailWasSentTo"), this.email);
  }

  okClicked() {
    this.onOk.emit();
  }

}
